module.exports = __webpack_public_path__ + "media/ROOM15sec.d6457633.mp4";